"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyPriceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var journey_services_1 = require("@ferry/journey-services");
var journey_services_2 = require("@athena-portal/journey-services");
var StickyPriceWidget = /** @class */ (function (_super) {
    __extends(StickyPriceWidget, _super);
    function StickyPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.visibilityBreakPoint = 250;
        _this.previousPremium = 0;
        _this.showOnScroll = function () {
            if (_this.state.visibilityClass === "d-none") {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
            }
            else {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
                else {
                    _this.setState({ visibilityClass: "hide" });
                }
            }
            var tierTableElements = document.getElementsByClassName("tier-table");
            if (tierTableElements.length > 0) {
                var tierTable = tierTableElements[0];
                var tierRect = tierTable.getBoundingClientRect();
                var showTierPremiums = tierRect.top <= 0 && tierRect.bottom >= 0;
                _this.setState({ showTierPremiums: showTierPremiums });
            }
        };
        if ((0, commonFunctions_1.isDriveAwayOrAnnualProduct)(_this.props.interaction.product)) {
            _this.previousPremium = _this.props.interaction.factors.premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL ?
                _this.props.interaction.factors.annualPremium : _this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        }
        _this.state = {
            premium: _this.props.interaction.factors.premium,
            visibilityClass: "d-none",
            rotationClass: "",
            displayMtaPremium: _this.getSetting("showMtaPremium", false),
            showAdditionalPremium: _this.getSetting("showAdditionalPremium", false),
            showReplaceCarMessage: _this.getSetting("showReplaceCarMessage", false),
            subProcess: _this.props.interaction.subProcess,
            additionalPremiumAmount: _this.props.interaction.factors.amountToPay,
            refundAmount: _this.props.interaction.factors.amountToRefund,
            showTierPremiums: false
        };
        window.addEventListener("scroll", _this.showOnScroll);
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    StickyPriceWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.interaction.factors.premium !== this.props.interaction.factors.premium ||
            prevProps.interaction.factors.amountToPay !== this.props.interaction.factors.amountToPay ||
            prevProps.interaction.subProcess !== prevProps.interaction.subProcess) {
            this.setState({ rotationClass: "rotate" });
        }
    };
    StickyPriceWidget.prototype.componentDidMount = function () {
    };
    StickyPriceWidget.prototype.render = function () {
        var _this = this;
        if (this.state.rotationClass === "rotate") {
            setTimeout(function () {
                _this.setState({
                    premium: _this.props.interaction.factors.premium,
                    additionalPremiumAmount: _this.props.interaction.factors.amountToPay,
                    subProcess: _this.props.interaction.subProcess,
                    refundAmount: _this.props.interaction.factors.amountToRefund
                });
            }, 500);
            setTimeout(function () {
                _this.setState({ rotationClass: "" });
            }, 1000);
        }
        var cssClass = this.getSetting("cssClass", "");
        return ((0, jsx_runtime_1.jsx)("div", { className: "sticky-price ".concat(cssClass, " ").concat(this.state.visibilityClass).concat(this.state.showTierPremiums ? " tiers pt-0" : ""), children: (0, jsx_runtime_1.jsx)("div", { className: this.state.showTierPremiums ? "container" : "sticky-price-background", children: this.state.showTierPremiums
                    ? this.renderTiers()
                    : this.renderStickyPrice() }) }));
    };
    StickyPriceWidget.prototype.renderStickyPrice = function () {
        if (this.previousPremium === 0 || this.previousPremium === null) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "d-inline-block ".concat(this.state.rotationClass), children: [this.premiumToRender(), this.additionalWording()] }));
    };
    StickyPriceWidget.prototype.premiumToRender = function () {
        if (this.state.showAdditionalPremium && this.state.additionalPremiumAmount) {
            return this.state.refundAmount > 0 ?
                (0, commonFunctions_1.getAmountWithDecimalDigits)(this.state.refundAmount) :
                (0, commonFunctions_1.getAmountWithDecimalDigits)(this.state.additionalPremiumAmount);
        }
        else if ((0, commonFunctions_1.isDriveAwayOrAnnualProduct)(this.props.interaction.product)) {
            var premiumToDisplay = void 0;
            if (this.props.interaction.factors.premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL) {
                premiumToDisplay = this.getAnnualPremium();
            }
            else {
                premiumToDisplay = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment === 0 ?
                    this.previousPremium : this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
            }
            this.previousPremium = premiumToDisplay;
            return (0, commonFunctions_1.getAmountWithDecimalDigits)(premiumToDisplay);
        }
        else {
            return (0, commonFunctions_1.getAmountWithDecimalDigits)(this.state.premium);
        }
    };
    StickyPriceWidget.prototype.getAnnualPremium = function () {
        if (this.props.interaction.factors.annualPremium === 0) {
            return this.previousPremium;
        }
        else {
            return this.props.interaction.process === journey_services_1.INTERACTION_PROCESS_NB ||
                this.props.interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL ?
                this.props.interaction.factors.amountToPay :
                this.props.interaction.factors.annualPremium;
        }
    };
    StickyPriceWidget.prototype.additionalWording = function () {
        if ((0, commonFunctions_1.isDriveAwayOrAnnualProduct)(this.props.interaction.product)) {
            return ((0, jsx_runtime_1.jsx)("span", { className: "fs-18", children: this.props.interaction.factors.premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL ? " / year" : " / month" }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    StickyPriceWidget.prototype.renderTiers = function () {
        var _this = this;
        var _a, _b;
        var selectedTierCode = (_b = (_a = this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.selectedCoverTier) !== null && _b !== void 0 ? _b : "";
        var tierSelected = this.props.interaction.uistate.readyForNextPage || false;
        var tierNotNull = !!selectedTierCode;
        var tiers = new Map();
        tiers.set(journey_services_1.ALLIANZ_ESSENTIALS, "Essentials");
        tiers.set(journey_services_1.ALLIANZ, "Plus");
        var checkBoxes = [];
        tiers.forEach(function (tierName, code) {
            var isChecked = _this.isChecked(code);
            var styleChecked = isChecked ? "tier-selected" : "tier-not-selected";
            var styleName = (!tierSelected && !tierNotNull) ? "tier-unselected" : styleChecked;
            var checkBox = ((0, jsx_runtime_1.jsx)("div", { className: "d-flex flex-column", children: (0, jsx_runtime_1.jsxs)("div", { className: "".concat(styleName, " tier-checkbox"), onKeyDown: function () { return _this.handleChange(code); }, onClick: function () { return _this.handleChange(code); }, children: [(0, jsx_runtime_1.jsx)("div", { className: "custom-radiobutton-container", children: (0, jsx_runtime_1.jsx)("input", { className: "custom-radiobutton", type: "radio", name: "".concat(code, " checkbox"), value: code, id: "".concat(code, " checkbox"), checked: isChecked, onChange: function () { return _this.handleChange(code); } }, "".concat(code, " input")) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "tier-name", children: tierName }), _this.renderTierPremium(code)] })] }) }, code));
            checkBoxes.push(checkBox);
        });
        return ((0, jsx_runtime_1.jsx)("div", { className: "journey-content", children: (0, jsx_runtime_1.jsxs)("div", { className: "row mr-0 ml-0 sticky-tiers", children: [(0, jsx_runtime_1.jsx)("div", { className: "fake-container" }), checkBoxes] }) }));
    };
    StickyPriceWidget.prototype.renderTierPremium = function (tier) {
        var _a;
        var factors = this.props.interaction.tieredFactors;
        var premiumType = this.props.interaction.factors.premiumType;
        var tierFactors = (0, commonFunctions_1.getTierFactors)(tier, factors);
        var annualPremium = tierFactors === null || tierFactors === void 0 ? void 0 : tierFactors.annualPremium;
        var monthlyPremium = tierFactors === null || tierFactors === void 0 ? void 0 : tierFactors.monthlyPremium;
        var premiumAmount = (premiumType === "annual") ? annualPremium : monthlyPremium;
        var premiumPeriodWording = (premiumType === "annual") ? "year" : "month";
        var promotionApplied = ((_a = this.props.interaction.promotions) === null || _a === void 0 ? void 0 : _a.promotionsApplied) === true;
        var promotions = this.props.interaction.promotions;
        var isFreeInsurance = false;
        if (promotions && promotions.promotionsDetails.length > 0) {
            isFreeInsurance = promotions.promotionsDetails[0].promotionType === "FREE_INSURANCE";
        }
        if (promotionApplied) {
            var priceToPay = tierFactors === null || tierFactors === void 0 ? void 0 : tierFactors.amountToPay;
            var voucherAmount = this.props.interaction.promotions.promotionsTotalValue;
            if (premiumType === "annual") {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "tier-premium-display", children: [(0, jsx_runtime_1.jsx)("span", { children: "Total cost: " }), (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountWithDecimalDigits)(premiumAmount) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { children: "Voucher: " }), (0, jsx_runtime_1.jsxs)("strong", { children: ["-", (0, commonFunctions_1.getAmountWithDecimalDigits)(isFreeInsurance ? premiumAmount : voucherAmount), "**"] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { children: "Price to pay: " }), (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountWithDecimalDigits)(priceToPay) }), (0, jsx_runtime_1.jsxs)("span", { className: "mb-0", children: [" / ", premiumPeriodWording, "*"] })] }));
            }
            else {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "tier-premium-display", children: [(0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountWithDecimalDigits)(premiumAmount) }), (0, jsx_runtime_1.jsxs)("span", { className: "mb-0", children: [" / ", premiumPeriodWording, "*"] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("span", { children: ["incl. a ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountWithDecimalDigits)(voucherAmount) }), " voucher**"] })] }));
            }
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "tier-premium-display", children: [(0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountWithDecimalDigits)(premiumAmount) }), (0, jsx_runtime_1.jsxs)("span", { className: "mb-0", children: [" / ", premiumPeriodWording, "*"] })] }));
    };
    StickyPriceWidget.prototype.isChecked = function (id) {
        var _a;
        var selectedTier = (_a = this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.selectedCoverTier;
        return selectedTier ? id === "".concat(selectedTier) : false;
    };
    StickyPriceWidget.prototype.handleChange = function (selectedTier) {
        if (this.props.interaction.process !== journey_services_1.INTERACTION_PROCESS_NB) {
            journey_services_2.ObjectManipulator.setField("uistate.upgradeToAllianz", this.props.interaction, selectedTier === "ALLIANZ");
        }
        journey_services_2.ObjectManipulator.setField(this.props.question.interactionField, this.props.interaction, selectedTier);
        journey_services_2.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, selectedTier);
        journey_services_2.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
        this.executeEvent("change");
    };
    return StickyPriceWidget;
}(plugin_journey_1.WidgetBase));
exports.StickyPriceWidget = StickyPriceWidget;
//# sourceMappingURL=StickyPriceWidget.js.map